import React from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router';
import { NavLink, Link } from 'react-router-dom';
import styled from 'styled-components/macro';

import LoginForm from './components/LoginForm';
import RestorePassword from './components/RestorePassword';

import logo from 'img/OLogo.png';
import loginMap from 'img/login-map.png';
import loginCar from 'img/login-car.png';
import areasIcon from 'img/areas-icon.svg';
import diagnosticIcon from 'img/diagnostic-icon.svg';
import notificationIcon from 'img/notification-icon.svg';

const Background = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-repeat: round;
  z-index: 10;
  background: linear-gradient(to top left, #9D9152 5%, #727276 45%, #536A80 90%);
`;

const MapImage = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-repeat: round;
  z-index: 20;
  background-image: url(${loginMap});

  @media (max-width: 964px) {
    display: none;
  }
`;

const CarImage = styled.div`
  display: inlibne-block;
  float: right;
  margin-top: 200px;
  margin-right: 100px;
  z-index: 30;
  background-image: url(${loginCar});
  width: 637px;
  height: 500px;
  background-repeat: round;

  @media (max-width: 1140px) {
    margin-right: 0;
  }
  
  @media (max-width: 1050px) {
    width: 567px;
    height: 450px;
  }

  @media (max-width: 964px) {
    display: none;
  }

  @media (min-height: 960px) {
    margin-top: 300px;
  }

  @media (min-height: 1200px) {
    margin-top: 400px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const LoginPage: React.SFC<RouteComponentProps> = ({
  match,
}) => (
  <ContentWrapper>
    <Background />
    <MapImage />
    <header className="header-main">
  		<div className="wrapper">
  			<div className="header-main__wrap">
  				<div className="header-main__logo">
  					<Link to="/" />
  					<img src={logo} alt="" />
  				</div>
  				{/* <ul className="header-main__tabs">
  					<li><TabLink to="/auth/login/service">Вход</TabLink></li>
  					<li><TabLink to="/auth/models">Модели</TabLink></li>
  				</ul> */}
  			</div>
  		</div>
  	</header>
    <section className="main">
      <div className="main-top">
        <div className="main-top__wrap">
          <div className="wrapper main-wrapper">
            <div className="main-top__wrap">
              <div className="main-top__descr">
                <p>Добро пожаловать</p>
                <h2>в ЛИЧНЫЙ КАБИНЕТ ДИЛЕРА</h2>
                <Switch>
                  <Route path={`${match.url}/login`} component={LoginForm} />
                  <Route path={`${match.url}/restore`} component={RestorePassword} />
                </Switch>
              </div>
              <CarImage />
            </div>
          </div>
        </div>
      </div>
    </section>
      <div className="main-bottom">
          <div className="wrapper">
            <div className="main-bottom__col">
              <div className="main-bottom__col-img">
                <img src={areasIcon} alt="" />
              </div>
              <div className="main-bottom__col-descr">
                <p>Зоны эксплуатации</p>
              </div>
            </div>
            <div className="main-bottom__col">
              <div className="main-bottom__col-img">
                <img src={diagnosticIcon} alt="" />
              </div>
              <div className="main-bottom__col-descr">
                <p>Удаленная диагностика</p>
              </div>
            </div>
            <div className="main-bottom__col">
              <div className="main-bottom__col-img">
                <img src={notificationIcon} alt="" />
              </div>
              <div className="main-bottom__col-descr">
                <p>Своевременное приглашение на ТО</p>
              </div>
            </div>
          </div>
        </div>
  </ContentWrapper>
);

export default LoginPage;
